import { getPathname, PpHero } from "@italymondo/core-ui";
import { CMSHeroData } from "./query";

export function formatData(data: CMSHeroData, showAlertBar: boolean): PpHero {
  if (!data) {
    throw new Error("Expected a site object");
  }

  return {
    description: data?.aboutPage[0].heroDescription || "",
    hasAlertBar: showAlertBar && !!data?.aboutPage[0].alertBar,
    headline: data?.aboutPage[0].heroHeadline || "",
    heroType: data?.aboutPage[0].heroType,
    primaryButton: data?.aboutPage[0]?.heroPrimaryButton
      ? {
          title: data?.aboutPage[0].heroPrimaryButton?.title,
          url: getPathname(data?.aboutPage[0]?.heroPrimaryButton?.page?.url),
        }
      : null,
    secondaryButton: data?.aboutPage[0]?.heroSecondaryButton
      ? {
          title: data?.aboutPage[0]?.heroSecondaryButton?.title,
          url: getPathname(data?.aboutPage[0]?.heroSecondaryButton?.page?.url),
        }
      : null,
    verticalText: data?.aboutPage[0].heroVerticalText?.name || "",
  };
}
